import { useCommonCurrentUser, useUpdateCookiePreferences } from "@/utils/api";
import { useFirebaseAuth } from "@/utils/firebase";
import { initAnalytics, initDevTools } from "@/utils/inits";
import { Cookie as CookieConsentUI } from "@repo/ui";
import { useCallback } from "react";

export default function Cookie() {
  const { data: user, isLoading } = useCommonCurrentUser();
  const { isCheckingAuth } = useFirebaseAuth();

  // Compose the current user's cookie status if available
  const currentUserCookieStatus = user
    ? {
      essential: true,
      analytics: user.data.cookies.analytics.accepted,
      developerAid: user.data.cookies.developerAid.accepted,
    }
    : undefined;

  // Handler to update cookie preferences in the backend if user is logged in
  const updateCookiePreferences = useUpdateCookiePreferences();

  const handleCookieStatusChange = useCallback(
    (status: { essential: boolean; analytics: boolean | undefined; developerAid: boolean | undefined }) => {
      if (updateCookiePreferences.isIdle && user && status.analytics !== undefined && status.developerAid !== undefined) {
        // Only update if there's an actual change
        const hasAnalyticsChanged = user.data.cookies.analytics.accepted !== status.analytics;
        const hasDeveloperAidChanged = user.data.cookies.developerAid.accepted !== status.developerAid;

        if (hasAnalyticsChanged || hasDeveloperAidChanged) {
          updateCookiePreferences.mutate({
            analytics: status.analytics,
            developerAid: status.developerAid,
          });
        }
      }

      // Initialize services only when enabled
      if (status.analytics) {
        initAnalytics();
      }
      if (status.developerAid) {
        initDevTools();
      }
    },
    [updateCookiePreferences, user]
  );

  return (
    <CookieConsentUI
      onCookieStatusChange={handleCookieStatusChange}
      currentUserCookieStatus={currentUserCookieStatus}
      isLoading={isCheckingAuth || isLoading}
    />
  );
}